import { formatDate } from '@angular/common';
import { Params } from '@angular/router';
import { DateFilter } from '../_models/filters/date-filter';

export function fromQueryParam(date: string): Date {
  return fromQueryParamOr(date, new Date());
}

export function fromQueryParamOr(date: string, defaultDate: Date): Date {
  const timestamp = Date.parse(date);
  if (isNaN(timestamp)) {
    return defaultDate;
  }

  return new Date(timestamp);
}

export function toQueryParams(dates: DateFilter): Params {
  return Object.entries(dates).reduce((prev, entry) => {
    prev[entry[0]] = formatDate(entry[1], 'yyyy-MM-dd', 'pl-Pl');
    return prev;
  }, {});
}
